import { Injectable } from '@angular/core';
import 'rxjs/add/operator/map';


@Injectable()
export class AuthenticationServiceProvider {

    authdata: String;

    constructor() {
        try{
            let account_json = JSON.parse(window.localStorage['account']);
            if("currentUser" in account_json){
                if("authdata" in account_json["currentUser"])
                    this.authdata = account_json["currentUser"]["authdata"];
            }
        }catch(e){
            console.log("Failed to parse authentication: ")
            console.log(e)
        }
    }


    SetCredentials(username, password, id) {
        this.authdata = btoa(username + ':' + password);

        var data = {
            currentUser: {
                username: username,
                authdata: this.authdata,
                id: id
            }
        }

        window.localStorage['account'] = JSON.stringify(data);
    };

    IsAuthenticated(){
        try {
            return "currentUser" in JSON.parse(window.localStorage['account']);
        }
        catch(e){
            console.log(e)
            return false;
        }
    }

    ClearCredentials () {
        window.localStorage['account'] = JSON.stringify({});
    }
}



// WEBPACK FOOTER //
// ./src/providers/authentication-service/authentication-service.ts